<ng-template #file>
	<div class="input-wrapper" #fileContent
		 *transloco="let t; read: 'formElements'"
		 (click)="browseFile($event)">
		<div class="progress-bar"
			 *ngIf="fileLoading"
			 [style.width.%]="progressValue">
		</div>
		<ng-container *ngIf="!fileLoading">
			<div class="file-info">
				<div class="file-name"
					 [class.file-loaded]="controlGroup.value?.id"
					 #fileName
					 [ngbTooltip]="showTooltip ? controlGroup.value?.fileName : ''"
					 container="body">
					{{ controlGroup.value?.id ? controlGroup.value?.fileName : t('generic.uploadFile') }}
				</div>
			</div>
		</ng-container>
		<button class="btn btn-outline-default btn-reset"
				*ngIf="controlGroup.value?.id || controlGroup.errors"
				(click)="reset($event)"
				type="button">
			{{ t('generic.reset') | uppercase }}
		</button>

		<div class="d-flex align-items-center justify-content-between">
			<shared-file-upload *ngIf="endpoint"
								#pondWrapper
								[extraClass]="'dark'"
								[endpoint]="endpoint"
								[instantUpload]="instantUpload"
								(done)="uploaded($event)"
								(loading)="fileLoading = $event"
								(click)="markFormGroup()"
								(remove)="removeFile()"
								(fileLoadingError)="fileLoadingError($event)"
								(processFileProgress)="processFileProgress($event)"></shared-file-upload>

			<div class="indicators-wrapper" *ngIf="controlGroup && !fileLoading">
				<div *ngIf="(controlGroup.touched || controlGroup.dirty) && controlGroup.errors" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fa-solid fa-xmark"></i>
				</span>
				</div>

				<div *ngIf="fileLoadSuccess && controlGroup.valid && (!controlGroup.pristine || controlGroup.value.id)" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fa-solid fa-check"></i>
				</span>
				</div>

				<div *ngIf="controlGroup.pristine && !controlGroup.disabled && isControlRequired && !controlGroup.touched && !controlGroup.value.id && !(warnings && warnings.deprecated)"
					 class="icon-indicator color-primary separator">
				<span class="inner-wrapper">
					<shared-icon-sprite svgId="asterisk" height="14px" width="12px" class="mb-1"></shared-icon-sprite>
				</span>
				</div>

				<div *ngIf="warnings && warnings.deprecated" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fal fa-exclamation-triangle"></i>
				</span>
				</div>

				<div *ngIf="controlGroup.disabled" class="icon-indicator separator">
				<span class="inner-wrapper">
					<shared-icon-sprite svgId="lock" height="22px" width="18px" class="mb-2"></shared-icon-sprite>
				</span>
				</div>

				<div class="icon-indicator separator">
				<span class="inner-wrapper file">
					<shared-icon-sprite svgId="file-text" height="22px" width="18px" class="mb-2"></shared-icon-sprite>
				</span>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #errors>
	<ng-container *ngIf="controlGroup.touched || controlGroup.dirty">
		<div class="control-errors-wrapper">
			<div [ngClass]="{'control-errors-vertical': template === ControlTemplate.vertical}"
				 class="control-errors col-12" *ngFor="let error of controlGroup.errors | keyvalue">
				<span class="error">{{error.value}}</span>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-template #horizontal>
	<div class="input-group input-horizontal">
		<div class="input-container"
			 [class.input-disabled]="controlGroup.disabled"
			 [class.input-container-pristine]="(controlGroup.pristine && !controlGroup.disabled)  || (controlGroup.touched && !!controlGroup.value?.id)"
			 [class.input-container-invalid]="(controlGroup.touched || controlGroup.dirty) && controlGroup.errors"
			 [class.input-container-valid]="controlGroup.valid && !!controlGroup.value?.id">
			<label [for]="id" class="w-100"
				   [class.input-valid]="controlGroup.valid"
				   [class.input-invalid]="(controlGroup.touched || controlGroup.dirty) && controlGroup.errors"
				   *transloco="let t; read: 'journal'">
				{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
						<span *ngIf="warning.value"
							  [ngbTooltip]="t('warnings.'+warning.key)"
							  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="file"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #vertical>
	<div class="input-group input-vertical p-0">
		<div class="input-container col-12 p-0"
			 [class.input-disabled]="controlGroup.disabled"
			 [class.input-container-pristine]="(controlGroup.pristine && !controlGroup.disabled)  || (controlGroup.touched && !!controlGroup.value?.id)"
			 [class.input-container-invalid]="(controlGroup.touched || controlGroup.dirty) && controlGroup.errors"
			 [class.input-container-valid]="controlGroup.valid && !!controlGroup.value?.id">
			<label [for]="id" class="w-100"
				   [class.input-valid]="controlGroup.valid"
				   [class.input-invalid]="(controlGroup.touched || controlGroup.dirty) && controlGroup.errors"
				   *transloco="let t; read: 'journal'">
				{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
						<span *ngIf="warning.value"
							  [ngbTooltip]="t('warnings.'+warning.key)"
							  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="file"></ng-container>
		</div>
	</div>
</ng-template>

<ng-container>
	<div [ngSwitch]="template" class="form-control-container">
		<ng-container *ngSwitchCase="ControlTemplate.horizontal">
			<ng-container *ngTemplateOutlet="horizontal"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.vertical">
			<ng-container *ngTemplateOutlet="vertical"></ng-container>
			<ng-container *ngTemplateOutlet="errors"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.inline">
			<h3 *ngIf="label" class="text-uppercase text-primary font-weight-700">{{label}}</h3>
			<ng-container *ngTemplateOutlet="file"></ng-container>
		</ng-container>
	</div>
</ng-container>


